import { Badge, Box, Button, Flex, Grid, Select } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBuildingStore,
  IconCalendar,
  IconSearch,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { _localization } from "../../../config/location";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../../model/MessageResponse";
import InputSearch from "../../../common/InputSearch/InputSearch";
import { DatePickerInput } from "@mantine/dates";
import { formatDateNotTimeZone } from "../../../common/FormatDate/FormatDate";
import dayjs from "dayjs";

export interface TblWarrantyReceipt {
  id: number;
  customerName: string | null;
  phoneNumber: string | null;
  email: string | null;
  provinceId: number | string | null;
  streetId: number | string | null;
  districtId: number | string | null;
  communeId: number | string | null;
  address: string | null;
  quantity: number | null;
  itemNote?: string | null;
  errorNote?: string | null;
  status?: string | null;
  attribute1: string | null;
  attribute2?: string | null;
  attribute3?: string | null;
  attribute4?: string | null;
  attribute5?: string | null;
  attribute6?: string | null;
  attribute7?: string | null;
  attribute8?: string | null;
  attribute9?: string | null;
  attribute10?: string | null;
  createBy?: number | null;
  createDate?: string | null; // hoặc Date nếu bạn parse về Date
  lastUpdateBy?: number | null;
  lastUpdateDate?: string | null; // hoặc Date nếu bạn parse về Date
}

const ListCustMeetingInfomation = ({
  setDataMeetingAddress,
  infoCust,
  setProvinceId,
  setDistrictId,
  setCommuneId,
  view,
}: {
  setDataMeetingAddress?: any;
  infoCust?: any;
  setProvinceId?: any;
  setDistrictId?: any;
  setCommuneId?: any;
  view: any;
}) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblWarrantyReceipt[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [pagination, setPagination] = useState(paginationBase);
  const [isFirstFetch, setIsFirstFetch] = useState(true);

  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);

  const initialBranchId = (() => {
    try {
      const userLogin = localStorage.getItem("userLogin");
      return userLogin ? JSON.parse(userLogin).branchId : null;
    } catch {
      return null;
    }
  })();

  const [search, setSearch] = useDebouncedState(
    {
      branchId: "",
      keySearch: "",
      startDate: formatDateNotTimeZone(dayjs().subtract(1, "day").toDate()),
      endDate: formatDateNotTimeZone(new Date()),
    },
    300,
  );

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  //#region  table
  const columns = React.useMemo<MRT_ColumnDef<TblWarrantyReceipt>[]>(
    () => [
      {
        accessorKey: "action",
        header: "Chọn",
        enableColumnActions: false,
        enableColumnFilter: false,
        enableSorting: false,
        enableResizing: false,
        size: 90,
        Cell: ({ row }) => (
          <Flex justify={"center"}>
            <Button
              variant="light"
              color="blue"
              size="sm"
              radius="md"
              style={{ fontWeight: 600, padding: "0 14px" }}
              onClick={() => {
                setDataMeetingAddress({
                  custMeeting: row.original.customerName,
                  province: row.original.provinceId,
                  district: row.original.districtId,
                  commune: row.original.communeId,
                  street: row.original.streetId ?? null,
                  custPhone: row.original.phoneNumber,
                  content: row.original.errorNote,
                  additionalAddress: row.original.address,
                });
                setProvinceId?.(row.original.provinceId);
                setDistrictId?.(row.original.districtId);
                setCommuneId?.(row.original.communeId);
                infoCust((prev: any) => ({
                  ...prev,
                  custId: row.original.id,
                  custMeeting: row.original.customerName,
                  custPhone: row.original.phoneNumber,
                  attribute2: row.original.id,
                  commune: row.original.communeId,
                  additionalAddress: row.original.address ?? null,
                  content: row.original.errorNote,
                }));
                modals.closeAll();
              }}
            >
              Chọn
            </Button>
          </Flex>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày yêu cầu",
        enableColumnActions: false,
        enableSorting: true,
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{dayjs(renderedCellValue).format("DD-MM-YYYY HH:mm")}</>
        ),
      },
      {
        accessorKey: "attribute2",
        header: "STT chờ",
        enableColumnActions: false,
        enableResizing: false,
        size: 90,
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 130,
        enableColumnActions: false,
        Cell: ({ row, renderedCellValue }) => (
          <>
            <Badge
              size="sm"
              bd={`1px solid ${
                renderedCellValue === "TAO_MOI" ? "violet" : "orange"
              }`}
              variant="light"
              color={renderedCellValue === "TAO_MOI" ? "violet" : "orange"}
            >
              {renderedCellValue === "TAO_MOI" ? "Tạo mới" : "Đã tiếp nhận"}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "customerName",
        header: "Họ và tên",
        enableColumnActions: false,
        size: 180,
      },
      {
        accessorKey: "phoneNumber",
        header: "Số điện thoại",
        enableColumnActions: false,
        size: 140,
      },
      {
        accessorKey: "itemNote",
        header: "Sản phẩm bảo hành",
        enableColumnActions: false,
        size: 200,
      },
      {
        accessorKey: "quantity",
        header: "Số lượng",
        enableColumnActions: false,
        size: 100,
      },
      {
        accessorKey: "errorNote",
        header: "Ghi chú lỗi",
        enableColumnActions: false,
        size: 200,
      },
      {
        accessorKey: "provinceName",
        header: "Tỉnh/Thành Phố",
        size: 160,
      },
      {
        accessorKey: "communeName",
        header: "Phường/Xã",
        enableColumnActions: false,
        size: 160,
      },
      {
        accessorKey: "address",
        header: "Địa chỉ cụ thể",
        enableColumnActions: false,
        size: 200,
      },
    ],
    [],
  );

  const fetchDataBranch = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      let result = response.data;
      setDataBranch(result);
    }
  };

  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const getColumnVisibility = () => {
    if (view === "VIEW") {
      return {
        action: false,
        edit: true,
      };
    } else if (view !== "VIEW") {
      return {
        edit: false,
        action: true,
      };
    }
  };

  const getDataCustMeeting = async () => {
    if (!data || data.length === 0) {
      setIsLoading(true);
    }
    setIsRefetching(true);
    setIsError(false);

    let url = `?Status=TAO_MOI&Skip=${
      pagination?.pageIndex * pagination?.pageSize
    }&Take=${pagination.pageSize}`;

    if (search.branchId) {
      url += `&BranchId=${search.branchId}`;
    }

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }

    if (search.startDate) {
      url += `&FromDate=${search.startDate}`;
    }

    if (search.endDate) {
      url += `&ToDate=${search.endDate}`;
    }

    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblWarrantyReceipt/get-list${url}`,
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount ?? 0);
        // setSelectIds([]);
        // table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  const table = useMantineReactTable({
    columns,
    data,
    layoutMode: "grid",
    manualSorting: false, // client-side sorting
    enableSorting: true,
    positionToolbarAlertBanner: "bottom",
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    //add custom action buttons to top-left of top toolbar
    renderToolbarInternalActions: () => <></>,
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["action"],
      },
      //  sorting: [{ id: "attribute2", desc: true }],
      columnVisibility: getColumnVisibility(),
      density: "xs",
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: view === "VIEW" ? height : 550,
        minHeight: view === "VIEW" ? height : 550,
        overflowY: "scroll",
      },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    rowCount,
    onPaginationChange: setPagination,
    manualFiltering: false,
    manualPagination: true,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: false,
      showSkeletons: isLoading,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["25", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList?.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 160 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (195 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, [height]);

  useEffect(() => {
    fetchDataBranch();
    getDataCustMeeting();
  }, []);

  useEffect(() => {
    // Khi dataBranch có dữ liệu, set branchId mặc định (nếu chưa có)
    if (dataBranch.length > 0 && !search.branchId && initialBranchId) {
      handleChangeSearchValue(String(initialBranchId), "branchId");
    }
  }, [dataBranch]);

  useEffect(() => {
    if (search.branchId && isFirstFetch) {
      getDataCustMeeting();
      setIsFirstFetch(false);
    }
  }, [search.branchId]);

  useEffect(() => {
    if (!isFirstFetch) {
      getDataCustMeeting();
    }
  }, [pagination]);

  // React.useEffect(() => {
  //   const newColumnVisibility = getColumnVisibility();
  //   if (table) {
  //     table.setColumnVisibility(newColumnVisibility);
  //   }
  // }, [table]);

  return (
    <Box mt={10} style={{ overflowX: "hidden" }}>
      <div ref={headerRef}>
        <Grid>
          <Grid.Col span={sizeGrid}>
            <InputSearch
              width="100%"
              placeholder="Từ khoá"
              onChange={(value) => {
                handleChangeSearchValue(value, "keySearch");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn chi nhánh"
              comboboxProps={{
                transitionProps: { transition: "pop", duration: 200 },
              }}
              value={
                dataBranch?.find(
                  (item: SelectListItemBase) => item.value === search.branchId,
                )?.value || null
              }
              leftSection={<IconBuildingStore color="#15aabf" />}
              nothingFoundMessage={"Loading..."}
              data={dataBranch
                ?.sort((a: any, b: any) => a.att2 - b.att2)
                .map((ele, index) => {
                  return {
                    label: ele.text,
                    value: ele.value,
                  };
                })
                .slice(1)}
              onChange={(value) => {
                handleChangeSearchValue(value || "", "branchId");
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              defaultValue={new Date(search.startDate)}
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "startDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              defaultValue={new Date(search.endDate)}
              placeholder="Đến ngày"
              leftSection={<IconCalendar color="#15aabf" />}
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(e) => {
                handleChangeSearchValue(
                  formatDateNotTimeZone(e) ?? "",
                  "endDate",
                );
              }}
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              leftSection={<IconSearch size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                getDataCustMeeting();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <MantineReactTable table={table} />
    </Box>
  );
};

export default ListCustMeetingInfomation;
